import { Component, Input, OnDestroy } from "@angular/core";
import { DataAccessService } from "@kells/apis/data-access";
import { AnalyticsService } from "@kells/apis/analytics";
import { map } from "rxjs/operators";
import { SubscriptionPlan } from "@kells/interfaces/patient";
import { SubSink } from "subsink";
import { MatDialog } from "@angular/material/dialog";
import { FindADentistSearchClick } from "apps/patient-reporting/src/app/shared/models/analytics/home-events";
import { MEMBER_PROVIDERS_LINK } from "../../constants";
import { DentalProviderUpgradePlanModalComponent } from "../dental-provider-upgrade-plan-modal/dental-provider-upgrade-plan-modal.component";
import { Observable } from "rxjs";
import { observeProperty } from "@kells/utils/angular";

@Component({
  selector: "koa-find-a-dentist",
  templateUrl: "./find-a-dentist.component.html",
  styleUrls: ["./find-a-dentist.component.scss"],
})
export class FindADentistComponent implements OnDestroy {
  public readonly MEMBER_PROVIDERS_LINK = MEMBER_PROVIDERS_LINK;

  @Input() plan: SubscriptionPlan;
  public readonly plan$: Observable<SubscriptionPlan> = observeProperty(
    this,
    "plan"
  );

  @Input() title = "KELLS Dental Network";

  public readonly isUpgradePlanVisible$ = this.plan$.pipe(
    map((plan) => plan !== SubscriptionPlan.Complete)
  );

  private _subs = new SubSink();

  constructor(
    private readonly dialog: MatDialog,
    public readonly data: DataAccessService,
    private readonly analyticsService: AnalyticsService
  ) {
    this._subs = new SubSink();
  }

  ngOnDestroy() {
    this._subs.unsubscribe();
  }

  public onSearchClick(event: Event) {
    event.preventDefault();
    this.analyticsService.record(FindADentistSearchClick({}));
  }

  public onSearchNowClick(event: Event, plan: SubscriptionPlan) {
    this.analyticsService.record(FindADentistSearchClick({}));

    if (plan !== SubscriptionPlan.Complete) {
      event.preventDefault();

      this.onUpgradePlanClick();
    }
  }

  public onUpgradePlanClick() {
    this.dialog.open(DentalProviderUpgradePlanModalComponent, {
      autoFocus: false,
      panelClass: ["reports-modal"],
      width: "1250px",
      maxWidth: "100%",
    });
  }
}
